import { render, staticRenderFns } from "./titleGroup.vue?vue&type=template&id=4bd30271&scoped=true"
import script from "./titleGroup.vue?vue&type=script&lang=js"
export * from "./titleGroup.vue?vue&type=script&lang=js"
import style0 from "./titleGroup.vue?vue&type=style&index=0&id=4bd30271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd30271",
  null
  
)

export default component.exports